"use client"

import { useState } from "react"
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material"
import { Cancel, Send } from "@mui/icons-material"
import CancelOrderReasonFields, { VERIFICATION_FAILED_REMARKS } from "./CancelOrderReasonFields"

export default function OrderCancelRemarkModal({ open, onClose, onSubmit }) {
  const [reason, setReason] = useState("")
  const [remark, setRemark] = useState("")
  const [buttonDis, setButtonDis] = useState(false)

  const isVerificationFailed = reason === "Verification Failed"
  const remarkFilledIn = isVerificationFailed
    ? remark.trim() && (VERIFICATION_FAILED_REMARKS.includes(remark) ? true : remark.trim().length > 0)
    : remark.trim().length > 0
  const canSubmit = reason.trim().length > 0 && remarkFilledIn

  const handleSubmit = () => {
    setButtonDis(true)
    onSubmit({ reason, remark })
    setReason("")
    setRemark("")
  }

  const handleClose = () => {
    setReason("")
    setRemark("")
    onClose()
  }

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>Cancel Order</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>Please provide the cancellation details below.</DialogContentText>
        <CancelOrderReasonFields
          reason={reason}
          remark={remark}
          onReasonChange={setReason}
          onRemarkChange={setRemark}
          remarkRequired
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button onClick={handleClose} variant="outlined" color="error" startIcon={<Cancel />}>
          Close
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          color="primary"
          startIcon={<Send />}
          disabled={!canSubmit || buttonDis}
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  )
}
